module.exports = __webpack_public_path__ + "img/mission-diversity-banner.jpg?7fdfcb557a3bb65523ff7216801a1f7a";